/* eslint-disable max-len */
import styled from 'styled-components';
import color from '../../configs/color';

const Wrapper = styled.div`
  padding: 16px 24px;
  background-color: ${color.white};
  border-radius: 12px;

  .component_calendar_header_wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 12px;
    border-bottom: 1px solid ${color.grey1};
    margin-bottom: 12px;
  }

  .ant-picker-content {
    thead th {
      color: ${color.orange1};
      font-weight: 600;
    }
  }

  .ant-radio-button-wrapper-checked:not([class*=' ant-radio-button-wrapper-disabled']).ant-radio-button-wrapper:first-child {
    border-right-color: ${color.orange1};
  }

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    color: ${color.orange1};
    border-color: ${color.orange1};
  }

  .ant-picker-cell .ant-picker-cell-inner {
    min-width: 46px;
    height: 46px;
    line-height: 46px;
  }

  .ant-picker-calendar {
    /* padding-top: 24px; */
  }

  .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {
    background: ${color.orange1};
    border-radius: 90px;
  }

  .ant-picker-cell-in-view.ant-picker-cell-today
    .ant-picker-cell-inner::before {
    border: none;
  }

  .component_calendar_content {
    color: ${color.black4};
    background-color: ${color.grey3};
    padding: 18px 22px;
    margin-top: 12px;
    border-radius: 12px;
    cursor: pointer;
    .font-paragraph_medium {
      margin-top: 12px;
    }
  }
`;

export default Wrapper;
